/**
 * Brand registry — the multi-tenant map for POP3D pop-up stores.
 *
 * Each slug is a brand bundle: { brand, products, moodTints }.
 * The active brand is chosen by URL path segment:
 *   /              → agency landing (POP3D itself)
 *   /luma          → LUMA beauty store
 *   /kinetic       → KINETIC supplements store
 *   /form          → FORM activewear store
 *
 * To add a real client: drop src/brands/<slug>.js, register it here.
 * Each store is one Vercel deploy, one URL — that's the "pop-up".
 */
import * as pop3d from './pop3d.js';
import * as luma from './luma.js';
import * as kinetic from './kinetic.js';
import * as form from './form.js';

export const brands = {
  pop3d,            // default / agency
  luma,             // beauty
  kinetic,          // supplements / health
  form,             // activewear / apparel
};

// Storefront slugs that get a standalone store (no agency wrapper).
export const STORE_SLUGS = ['luma', 'kinetic', 'form'];

// Verticals shown on the agency landing as "what we build".
export const SHOWCASE = [
  { slug: 'luma',    label: 'LUMA',    vertical: 'Beauty',              tint: '#ff5e8a' },
  { slug: 'kinetic', label: 'KINETIC', vertical: 'Supplements / Health', tint: '#39ff14' },
  { slug: 'form',    label: 'FORM',    vertical: 'Activewear',          tint: '#00ffff' },
];

/**
 * Read the first path segment and resolve a brand slug.
 * Returns { slug, bundle, isStore }.
 */
export function resolveBrandSlug(pathname = (typeof window !== 'undefined' ? window.location.pathname : '/')) {
  const seg = pathname.split('/').filter(Boolean)[0]?.toLowerCase();
  if (seg && brands[seg]) {
    return { slug: seg, bundle: brands[seg], isStore: STORE_SLUGS.includes(seg) };
  }
  return { slug: 'pop3d', bundle: brands.pop3d, isStore: false };
}
